// M09 - EducaFilesToolbar
//
// Barra superior del panel principal: filtros por tipo y visibilidad,
// busqueda libre por nombre/descripcion, y boton primario "Subir".

import React from "react";
import { Input, Select, Button, Space } from "antd";
import {
  CloudUploadOutlined,
  FileImageOutlined,
  VideoCameraOutlined,
  AudioOutlined,
  FilePdfOutlined,
  FileZipOutlined,
  GlobalOutlined,
  LockOutlined,
} from "@ant-design/icons";
import styles from "./EducaFilesToolbar.module.scss";

const KIND_OPTIONS = [
  { value: "", label: "Todos los tipos" },
  { value: "image", label: "Imagenes", icon: <FileImageOutlined /> },
  { value: "video", label: "Videos", icon: <VideoCameraOutlined /> },
  { value: "audio", label: "Audio", icon: <AudioOutlined /> },
  { value: "doc", label: "Documentos", icon: <FilePdfOutlined /> },
  { value: "archive", label: "Comprimidos", icon: <FileZipOutlined /> },
];

const VIS_OPTIONS = [
  { value: "", label: "Todas las visibilidades" },
  { value: "public", label: "Publicas", icon: <GlobalOutlined /> },
  { value: "private", label: "Privadas", icon: <LockOutlined /> },
];

function decorate(opts) {
  return opts.map((o) => ({
    value: o.value,
    label: (
      <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
        {o.icon}
        {o.label}
      </span>
    ),
  }));
}

export function EducaFilesToolbar({ filters, onFiltersChange, onUpload }) {
  const update = (patch) => onFiltersChange({ ...filters, ...patch });
  return (
    <div className={styles.toolbar}>
      <Space wrap size={[10, 10]} className={styles.left}>
        <Input.Search
          allowClear
          placeholder="Buscar por nombre o descripcion"
          value={filters.q}
          onChange={(e) => update({ q: e.target.value })}
          className={styles.search}
          size="middle"
        />
        <Select
          value={filters.kind}
          onChange={(v) => update({ kind: v })}
          options={decorate(KIND_OPTIONS)}
          size="middle"
          className={styles.select}
        />
        <Select
          value={filters.visibility}
          onChange={(v) => update({ visibility: v })}
          options={decorate(VIS_OPTIONS)}
          size="middle"
          className={styles.select}
        />
      </Space>
      <Button type="primary" icon={<CloudUploadOutlined />} onClick={onUpload}>
        Subir fichero
      </Button>
    </div>
  );
}
